import { Component, computed, HostListener, inject, input, model } from '@angular/core';
import { OfferImage } from '../../../../services/offers/offer-image.model';
import { CoreModule } from '@toevla-webapplications/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
	selector: 'ivva-image-carousel',
	templateUrl: './image-carousel.component.html',
	styleUrls: ['./image-carousel.component.scss'],
	imports: [CoreModule],
})
export class ImageCarouselComponent {
	images = input.required<Partial<OfferImage>[]>();
	index = model.required<number | null>();
	full = computed(() => {
		const index = this.index();

		if (index !== null) {
			return this.images()[index];
		}

		return null;
	});

	sanitizer = inject(DomSanitizer);

	@HostListener('document:keydown.Escape')
	doClose() {
		this.index.set(null);
	}

	@HostListener('document:keydown.ArrowLeft')
	previous() {
		this.index.update((i) => {
			if (i !== null && i > 0) {
				return i - 1;
			}

			return i;
		});
	}

	@HostListener('document:keydown.ArrowRight')
	next() {
		this.index.update((i) => {
			if (i !== null && i < this.images().length - 1) {
				return i + 1;
			}

			return i;
		});
	}

	getEmbedUrl(image: Partial<OfferImage>): SafeResourceUrl | null {
		const youtube = image.youtubeUrl?.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/);

		if (youtube) {
			return this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube-nocookie.com/embed/${youtube[1]}`);
		}

		return null;
	}
}
